import { React, useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import {
  Button,
  Divider,
  IconButton,
  Typography,
  TextField,
  Container,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import { useDispatch, useSelector } from 'react-redux';
import {
  acceptProject,
  getProjectInfoAdmin2,
  getProjectInfoAdmin2Return,
  rejectProject,
} from '../../Actions/ProjectInfoAdmin';
import Fuse from 'fuse.js';
import SearchIcon from '@mui/icons-material/Search';
import { Box } from '@mui/system';

const columns = [
  { no: 1, id: 'name', label: 'Name', minWidth: 100 },
  { no: 2, id: 'title', label: 'Title', minWidth: 100 },

  {
    no: 3,
    id: 'projectCategories',
    label: 'Project Categories',
    minWidth: 100,
    align: 'left',
    format: value => value.toLocaleString('en-US'),
  },
  {
    no: 4,
    id: 'department',
    label: 'Department',
    minWidth: 100,
    align: 'left',
    format: value => value.toFixed(2),
  },
  {
    no: 5,
    id: 'facultyId',
    label: 'Faculty ID',
    minWidth: 100,
    align: 'left',
    format: value => value.toLocaleString('en-US'),
  },
  {
    no: 6,
    id: 'startDate',
    label: 'Start Date',
    minWidth: 100,
    align: 'left',
    format: value => value.toFixed(2),
  },
  {
    no: 7,
    id: 'endDate',
    label: 'End Date',
    minWidth: 100,
    align: 'left',
    format: value => value.toFixed(2),
  },
  {
    no: 8,
    id: 'email',
    label: 'Email',
    minWidth: 100,
    align: 'left',
    format: value => value.toFixed(2),
  },
  {
    no: 9,
    id: 'projUrl',
    label: 'Project Name',
    minWidth: 100,
    align: 'left',
    format: value => value.toFixed(2),
  },
];

function createData(id, name, title, projectCategories, department, facultyId, startDate, endDate, email, projUrl) {
  return { id, name, title, projectCategories, department, facultyId, startDate, endDate, email, projUrl };
}

var originalRows = [];

export default function VerifyContent() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState(originalRows);
  const [searched, setSearched] = useState('');
  const [tableData, settableData] = useState([]);
  const [query, updateQuery] = useState('');
  const [forceRerender, setForceRerender] = useState(true);
  const [dialogText, setDialogText] = useState('');
  const [open, setOpen] = useState(false);
  const token = useSelector(state => state.user.loginData);
  const dispatch = useDispatch();
  const Data = useSelector(state => state.projectData.newsData);
  const userData = JSON.parse(localStorage.getItem('access_token'));

  useEffect(() => {
    (async function () {
      const data = await getProjectInfoAdmin2Return(userData.token);
      settableData(data);
    })();
  }, []);

  const handleDialogText = e => {
    setDialogText(e.target.value);
  };
  const handleDialogSubmit = async row => {
    //dialog text is to be sent here as an api data
    dispatch(rejectProject({ userEmail: row.userEmail, paperID: row._id, rejectMessage: dialogText }, userData.token));
    dispatch(getProjectInfoAdmin2(userData.token));
    const data = await getProjectInfoAdmin2Return(userData.token);
    settableData(data);
    // setForceRerender(!forceRerender);

    setOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const fuse = new Fuse(originalRows, {
    keys: [
      'id',
      'name',
      'title',
      'projectCategories',
      'department',
      'facultyId',
      'startDate',
      'endDate',
      'email',
      'projUrl',
    ],
  });

  const results = fuse.search(query);

  function handleOnSearch({ currentTarget = {} }) {
    const { value } = currentTarget;
    updateQuery(value);
  }
  useEffect(() => {
    const filteredRows = query ? results.map(result => result.item) : originalRows;

    settableData([...filteredRows]);
  }, [query]);

  // useEffect(() => {
  //   dispatch(getProjectInfoAdmin2(userData.token));
  // }, [dispatch,forceRerender]);

  useEffect(() => {
    originalRows = [];

    if (Data) {
      Data.map(data =>
        originalRows.push(
          createData(
            data._id,
            data.name,
            data.title,
            data.category,
            data.department,
            data.empID,
            data.startDate.substr(0, 10),
            data.endDate.substr(0, 10),
            data.userEmail,
            data.fileName,
          ),
        ),
      );
    }
    originalRows.sort(function (a, b) {
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return new Date(b.startDate) - new Date(a.startDate);
    });
    settableData([...originalRows]);
  }, [Data, forceRerender]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  async function acceptData(row) {
    dispatch(acceptProject({ userEmail: row.userEmail, paperID: row._id, message: 'Good work' }, userData.token));
    dispatch(getProjectInfoAdmin2(userData.token));
    const data = await getProjectInfoAdmin2Return(userData.token);
    settableData(data);
    // setForceRerender(!forceRerender);
  }

  function rejectData() {
    setOpen(true);
  }
  function viewData(row) {
    window.open(row.fileName);
    console.log(row);
  }

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden', my: 5 }}>
      <Container
        sx={{
          display: 'flex',
          flexDirection: ['column', 'row', 'row'],
          justifyContent: ['center', 'space-between', 'space-between'],
          px: 0,
        }}
      >
        <Typography
          gutterBottom
          variant="h5"
          component="h2"
          fontWeight="bold"
          fontFamily="Sora"
          display="flex"
          justifyContent="left"
          alignItems="center"
          paddingTop="10px"
          paddingLeft="10px"
          fontSize="25px"
          sx={{ justifyContent: ['left', 'left', 'left'], marginLeft: [1, 0, 0] }}
        >
          All Enquiries
        </Typography>
        {/* // TODO: Search Needs to be Fixed */}
        {/* //! Removing it for the time being */}
        {/* <div style={{ padding: 20 }}>
          <TextField
            placeholder="Search"
            value={query}
            onChange={handleOnSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div> */}
      </Container>
      <Divider />
      <TableContainer sx={{ maxHeight: 500 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map(column =>
                column.id !== 'id' && column.id !== 'email' && column.id !== 'projUrl' ? (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    sx={{ fontFamily: 'Sora', color: '#707070' }}
                  >
                    {column.label}
                  </TableCell>
                ) : (
                  <></>
                ),
              )}
              <TableCell sx={{ fontFamily: 'Sora', color: '#707070' }}>Request</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => {
              return (
                <>
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {columns.map(column => {
                      const value = row[column.id];

                      return column.id !== 'id' &&
                        column.id !== 'email' &&
                        column.id !== 'projUrl' &&
                        column.id !== 'projectCategories' ? (
                        <>
                          <TableCell key={column.id} align={column.align} sx={{ fontFamily: 'Sora' }}>
                            {column.format && typeof value === 'number' ? column.format(value) : value}
                          </TableCell>
                        </>
                      ) : column.id === 'projectCategories' ? (
                        <TableCell key={column.id} align={column.align} sx={{ fontFamily: 'Sora' }}>
                          <Box sx={{ minWidth: 100 }}>
                            <FormControl fullWidth>
                              <InputLabel id="demo-simple-select-label">{row.category[0] ?? 'NA'}</InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                              // value={row.category[0]}
                              >
                                {row?.category?.map(data => (
                                  <MenuItem>{data}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Box>
                        </TableCell>
                      ) : (
                        <></>
                      );
                    })}
                    <TableCell sx={{ display: 'flex', gap: '1vw', flexDirection: 'row', justifyContent: 'space-between', height: '12.5vh' }}>
                      <IconButton
                        onClick={() => viewData(row)}
                        sx={{ border: 2, width: '40px', height: '40px', borderColor: '#FF7345' }}
                      >
                        <ExpandCircleDownIcon sx={{ color: '#FF7345', backgroundColor: 'smoke', fontFamily: 'Sora' }} />
                      </IconButton>
                      {/* <Button
                        onClick={() => viewData(row)}
                        sx={{ color: '#FF7345', backgroundColor: 'smoke', marginRight: 1, fontFamily: 'Sora' }}
                        variant="outlined"
                        startIcon={<ExpandCircleDownIcon />}
                      >
                        View
                      </Button> */}
                      <IconButton
                        onClick={() => acceptData(row)}
                        sx={{ border: 2, width: '40px', height: '40px', borderColor: 'green' }}
                      >
                        <DoneIcon sx={{ color: 'green', backgroundColor: 'smoke', fontFamily: 'Sora' }} />
                      </IconButton>
                      {/* <Button
                        variant="outlined"
                        sx={{ color: '#FF7345', backgroundColor: 'smoke', marginRight: 1, fontFamily: 'Sora' }}
                        startIcon={<DoneIcon />}
                        onClick={() => acceptData(row)}
                      >
                        Accept
                      </Button> */}

                      <IconButton
                        onClick={() => rejectData()}
                        sx={{ border: 2, width: '40px', height: '40px', borderColor: 'red' }}
                      >
                        <CloseIcon sx={{ color: 'red' }} />
                      </IconButton>
                      <Dialog open={open} onClose={handleClose}>
                        <DialogTitle sx={{ width: ['100%', '100%', '500px'], fontFamily: 'Sora' }}>
                          REJECT PAPER
                        </DialogTitle>
                        <DialogContent>
                          <DialogContentText sx={{ fontFamily: 'Sora' }}>
                            Enter the reason for rejecting the paper
                          </DialogContentText>
                          <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Reason"
                            fullWidth
                            variant="standard"
                            onChange={handleDialogText}
                            value={dialogText}
                          />
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={handleClose}
                            sx={{
                              backgroundColor: '#F95329',
                              color: 'white',
                              border: 0,

                              fontFamily: 'Sora',

                              '&:hover': {
                                backgroundColor: 'red',
                              },
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={() => handleDialogSubmit(row)}
                            sx={{
                              backgroundColor: '#FF7345',
                              color: 'white',
                              border: 0,

                              fontFamily: 'Sora',

                              '&:hover': {
                                backgroundColor: '#d95429',
                              },
                            }}
                          >
                            Submit
                          </Button>
                        </DialogActions>
                      </Dialog>

                      {/* <Button
                        onClick={() => rejectData(row)}
                        sx={{ color: 'red' }}
                        variant="outlined"
                        startIcon={<CloseIcon />}
                      >
                        Decline
                      </Button> */}
                    </TableCell>
                  </TableRow>
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
